import { getDataBase } from '../db';

export default class ReglaLecturacionDetalleDAL {
    constructor() {
      this.ReglaLec = "ReglaLecturacionDetalle";
      this.Normal = "Normal";
      this.Bajo = "Bajo";
      this.Alto = "Alto";
      this.Cero = "Cero";
      this.Negativo = "Negativo";
      this.SinLectura = "SinLectura";
      this.Asignado = "Asignado";
    }
  
    async ReglaAplicable(tnTipoConsumo) {
      let lcTipoConsumo = await this.GetFieldName(tnTipoConsumo);
  
      return lcTipoConsumo != "null";
    }
  
    async GetFieldName(tnTipoConsumo) {
      let lcResult = "";
      switch (Number(tnTipoConsumo)) {
        case 1:
          lcResult = "Normal";
          break;
        case 2:
          lcResult = "Bajo";
          break;
        case 3:
          lcResult = "Alto";
          break;
        case 4:
          lcResult = "Cero";
          break;
        case 5:
          lcResult = "Negativo";
          break;
        case 6:
          lcResult = "SinLectura";
          break;
        case 7:
          lcResult = "Asignado";
          break;
        default:
          lcResult = "null";
          break;
      }
      return lcResult;
    }
  

    async GetIDBy(Regla, DataBaseAlias) {

      //traer de la base de datos indexDB
      try {
          const db = await getDataBase();
          const tx = db.transaction('REGLALECTURACIONDETALLE', 'readonly');
          const store = tx.objectStore('REGLALECTURACIONDETALLE');
          // const lecturasPendientes = await store.getAll();
          const lecturasPendientes = await store.getAll(Number(Regla));
          await tx.done;
          return lecturasPendientes;
      } catch (error) {
        console.error('Error al obtener lecturas pendientes:', error);
        return [];
      }
    }
  }
  